
import couponSelect from "../drawer/couponSelect.vue"

export default {
  components: {
    couponSelect
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    couponCodeList: {
      type: Array,
      default: () => []
    },
    checkoutParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    onCouponSave(val) {
      this.$emit("changed", {
        couponCodeList: val.map(item => item.couponCode),
        tradeCouponVOs: val.map(item => ({
          couponCode: item.couponCode,
          storeId: item.storeId
        }))
      })
    },
    handleOpen() {
      this.visible = true
      this.$emit("opend")
    },
    onCouponClose(isRefresh = false) {
      this.visible = false
      if (isRefresh) {
        this.$emit("changed", {})
      }
    }
  }
}
